import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import { C as CollapsibleCardHeaderStyled, D as DiscloseIcon, a as CardHeaderContentStyled, b as CardHeaderStyled } from './CardHeader.styles-C3NhanzD.js';
import { T as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { f as angleUp } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-sBnDaVj5-23EprBeB.js';

class CardHeader extends PureComponent {
  render() {
    const {
      children,
      collapsable,
      isCollapsed,
      onCollapse,
      padding,
      cardPadding,
      taktId,
      taktValue,
      ...rest
    } = this.props;
    const headerPadding = padding === 'inherit' ? cardPadding : padding;
    return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('card-header')
    }, ({
      getDataTaktAttributes
    }) => {
      if (collapsable) {
        return /*#__PURE__*/React__default.createElement(CollapsibleCardHeaderStyled, _extends({}, getDataTaktAttributes(), rest, {
          "aria-expanded": !isCollapsed,
          tabIndex: 0,
          collapsable: collapsable,
          onClick: onCollapse,
          isCollapsed: isCollapsed,
          padding: headerPadding
        }), /*#__PURE__*/React__default.createElement(DiscloseIcon, {
          type: angleUp
        }), /*#__PURE__*/React__default.createElement(CardHeaderContentStyled, null, children));
      }
      return /*#__PURE__*/React__default.createElement(CardHeaderStyled, _extends({}, rest, {
        padding: headerPadding
      }), children);
    });
  }
}

// Temporary fix until CommunicationsHubSharedAssets updates their
// StyledCardHeader's isCollapsed type in CommunicationCard.tsx
_defineProperty(CardHeader, "displayName", 'CardHeader');
_defineProperty(CardHeader, "propTypes", {
  /**
   * This is the content that will be shown in the CardHeader.
   */
  children: PT.node.isRequired,
  /**
   * Specifies whether the card is collapsed. When `true` only the `<CardHeader />`
   * is displayed.
   */
  isCollapsed: PT.bool,
  /**
   * Specifies that the card can be collapsed. The `<CardHeader />` component then
   * renders as a click target which collapses the card when clicked.
   */
  collapsable: PT.bool,
  /**
   * Event handler that is triggered when the user clicks the header.
   */
  onCollapse: PT.func,
  /**
   * Sets the padding around the `<CardHeader />`.
   */
  padding: PT.oneOf(['inherit', 'none', 'micro', 'mini', 'small', 'base', 'medium', 'large', 'xlarge', 'xxlarge']),
  /**
   * Passed in by the parent `<Card />` component. This is the padding value for
   * the `<Card />`.
   */
  cardPadding: PT.oneOf(['none', 'micro', 'mini', 'small', 'base', 'medium', 'large', 'xlarge', 'xxlarge'])
});
_defineProperty(CardHeader, "defaultProps", {
  isCollapsed: false,
  collapsable: false,
  onCollapse: undefined,
  padding: 'inherit',
  cardPadding: 'xlarge',
  tabIndex: undefined
});

export { CardHeader as C };
//# sourceMappingURL=CardHeader-CsuV374_.js.map
